import { render, staticRenderFns } from "./BaseSignaturePad.vue?vue&type=template&id=bcd8b862&scoped=true&"
import script from "./BaseSignaturePad.vue?vue&type=script&lang=js&"
export * from "./BaseSignaturePad.vue?vue&type=script&lang=js&"
import style0 from "./BaseSignaturePad.vue?vue&type=style&index=0&id=bcd8b862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd8b862",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
installComponents(component, {VBtn,VIcon,VLabel})
